/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Filter1Icon from '@mui/icons-material/Filter1';
import PortraitIcon from '@mui/icons-material/Portrait';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import BuildIcon from '@mui/icons-material/Build';
import MoneyIcon from '@mui/icons-material/Money';
import DateIcon from '@mui/icons-material/DateRange';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import WorkIcon from '@mui/icons-material/Work';
import CategoryIcon from '@mui/icons-material/Category';
import { User } from './UserModel';

export interface ServiceCaseData {
    id: string,
    serialnumber: string,
    opendate: string,
    updateddate: string,
    closeddate: string,
    failuredescription: string,
    warrantystatus: string,
    servicepart: string,
    servicepartserialnumber:string,
    serviceoperation: string,
    status: number,
    summary: Array<SummaryData>,
    instrument: InstrumentData,
    assigneduser: User,
    closedbyuser: User,
    age: number,
    servicebulletin: string,
    gsbusinessarea: string
}

export interface SummaryData {
    stepstakentoverifyfailure: string,
    productanalysis: string,
    warrantylabour: number,
    billablelabour: number,
    labourtype: string,
    repairdescription: string,
    symptom: string,
    failure: string,
    repairtime: string,
    swonumber:string 
}

export interface InstrumentData {
    partnumber: string,
    description: string
    productmodel: ProductModelData
}

export interface ProductModelData {
    product: ProductData
    model:ModelData
}

export interface ProductData {
    displayname: string,
    productline: string,
  imagename: string,
  twodproductname:TwodProductNameData
}

export interface ModelData {
  modelname: string,
  twodproductmodel:TwodProductModelData
}
export interface TwodProductModelData {
  name: string,
  twodproductname:TwodProductNameData
}
export interface TwodProductNameData {
  name: string
}

export const serviceCaseSearchSuggestions = [
    {
        Icon: Filter1Icon,
        toolTip: 'Case Id',
        suffix: ' in Case Id',
        searchProp: 'id'
    },
    {
        Icon: MoneyIcon,
        toolTip: 'Serial No',
        suffix: ' in Serial No',
        searchProp: 'serialnumber'
    },
    {
        Icon: BuildIcon,
        toolTip: 'Part No',
        suffix: ' in Part No',
        searchProp: 'partnumber'
    },
    {
        Icon: DescriptionIcon,
        toolTip: 'Description',
        suffix: ' in Description',
        searchProp: 'description'
    },
    {
        Icon: PortraitIcon,
        toolTip: 'User Name',
        suffix: ' in User Name',
        searchProp: 'username'
  },
    /*{
      Icon: DateIcon,
      toolTip: "Open Date",
      suffix: `in Open Date Eg ${new Date("2019-05-30").toLocaleDateString()}`,
      searchProp: "opendate"
    },
    {
      Icon: CalendarIcon,
      toolTip: "Closed Date",
      suffix: `in Closed Date Eg ${new Date("2019-05-30").toLocaleDateString()}`,
      searchProp: "closeddate"
    },*/
    {
        Icon: WorkIcon,
        toolTip: 'Company',
        suffix: `in Company`,
        searchProp: 'company'
    },
    {
        Icon: CategoryIcon,
        toolTip: 'Product Name',
        suffix: `in Product Name`,
      searchProp: 'productline'
    },
    {
        Icon: DescriptionIcon,
        toolTip: 'Product Model',
        suffix: `in Product Model`,
      searchProp: 'model'
    },
    {
        Icon: DescriptionIcon,
        toolTip: 'Failure Description',
        suffix: `in Failure Description`,
        searchProp: 'failuredescription'
    },
    {
        Icon: DescriptionIcon,
        toolTip: 'Detailed Description of service',
        suffix: `in Detailed Description of service`,
        searchProp: 'repairdescription'
    },
    //{
    //    Icon: DescriptionIcon,
    //    toolTip: "Warranty Status",
    //    suffix: `in Warranty Status`,
    //    searchProp: "warrantystatus"
    //},
      /*{
      Icon: AccessTimeIcon,
      toolTip: "Repair Time",
      suffix: " in Repair Time Eg 5h 30",
      searchProp: "repairtime"
    },
    { Icon: TimelapseIcon, toolTip: "Days Open", suffix: " in Days Open", searchProp: "age" }*/
];


export const exportServiceCaseColumnAttributesPdf = {
    'Case ID': { halign: 'center', cellWidth: 50 },
    'Serial No.': { halign: 'center', cellWidth: 65 },
    'Part No.': { halign: 'center', cellWidth: 65 },
    'Description': { halign: 'left', cellWidth: 110 },
    'Name': { halign: 'center', cellWidth: 70 },
    'Open Date': { halign: 'left', cellWidth: 65 },
    'Closed Date': { halign: 'left', cellWidth: 65 },
    'Failure Description': { halign: 'left', cellWidth: 85 },
    'Detailed Description of service': { halign: 'left', cellWidth: 85 },
    'Repair Time': { halign: 'center', cellWidth: 50 },
    'Days Open': { halign: 'center', cellWidth: 50 }
}

export const exportAllServiceCaseColumnAttributesPdf = {
    'Case ID': { halign: 'center', cellWidth: 45 },
    'Serial No.': { halign: 'center', cellWidth: 40 },
    'Part No.': { halign: 'center', cellWidth: 50 },
    'Description': { halign: 'left', cellWidth: 50 },
    'Name': { halign: 'center', cellWidth: 50 },
    'Company': { halign: 'center', cellWidth: 60 },
    'Open Date': { halign: 'left', cellWidth: 50 },
    'Updated Date': { halign: 'left', cellWidth: 50 },
    'Closed Date': { halign: 'left', cellWidth: 50 },
    'Product Name': { halign: 'center', cellWidth: 50 },
    'Product Model': { halign: 'center', cellWidth: 50 },
    'Warranty Status': { halign: 'left', cellWidth: 60 },
    'Failure Description': { halign: 'left', cellWidth: 65 },
    'Detailed Description of service': { halign: 'left', cellWidth: 70 },
    'Symptom': { halign: 'left', cellWidth: 55 },
    'Failure': { halign: 'left', cellWidth: 50 },
    'Service Part': { halign: 'left', cellWidth: 50 },
    'ServicePart(S No.)': { halign: 'left', cellWidth: 50 },
    'Service Operation': { halign: 'left', cellWidth: 60 },
    'Repair Time': { halign: 'center', cellWidth: 40 },
    'Days Open': { halign: 'center', cellWidth: 40 },
    'Service Bulletin': { halign: 'center', cellWidth: 70 },
    'Steps taken to verify failure': { halign: 'center', cellWidth: 70 },
    'Product Analysis': { halign: 'center', cellWidth: 70 },
    'GS Business Area': { halign: 'center', cellWidth: 150 },
    'SWO Ticket Number': {halign:'center',cellWidth:70}
};
